import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SocialShare from "./components/SocialShare";
import Home from "./pages/Home";
import Candidato from "./pages/Candidato";
import Sentencias from "./components/data/elecciones2022.json";
import { MyContext } from "./components/Context.js";
import Logo from "./logoedmundo.png";

function App() {
  const [candidatos, setCandidatos] = useState(null);

  const initData = () => {
    let initList = Sentencias.map((item) => {
      return {
        year: item.year,
        candidato: item.sancionado,
        cargo: item.cargo_funcional,
        dni: item.nro_procedimiento,
        decision: item.decision_final,
        region: item.region,
        estado: item.estado,
        resolucion: item.resolucion,
        link: item.resolucion_link,
        fecha: item.fecha,
        delito: item.eje,
      };
    });
    return initList;
  };

  useEffect(() => {
    // Data inicial
    const joinData = initData();

    // Agrupar e inicializar
    setCandidatos(joinData);
    MyContext.candidatos = joinData;
  }, []);

  return (
    <div className="App">
      <header className="App-header mb-4 px-4 py-3">
        <div className="row no-gutters align-items-center">
          <div className="col-md-9 col-8">
            <a href="https://edmundocruz.com/" target="_blank" rel="noreferrer">
              <img src={Logo} className="img-header" alt="Edmundo Cruz" />
            </a>
          </div>
          <div className="col-md-3 col-4">
            <SocialShare
              url={process.env.REACT_APP_URL}
              text="Buscador de jueces y fiscales sancionados"
            />
          </div>
        </div>
      </header>
      <MyContext.Provider value={{ candidatos: candidatos }}>
        <BrowserRouter basename="/especiales/jueces-fiscales-sancionados">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/:slug" element={<Candidato />} />
          </Routes>
        </BrowserRouter>
      </MyContext.Provider>
      <br></br>
      <br></br>
      <footer className="py-5">
        <hr></hr>
        <div className="container mt-5">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-4 col-xs-12 mr-md-5 mb-4 mb-md-0">
              <a
                href="https://edmundocruz.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Logo} className="" alt="Edmundo Cruz" />
              </a>
            </div>

            <div className="col-md-6 col-xs-12">
              <div className="">
                <div>
                  <small>
                    <strong>Elaboración:</strong>
                  </small>
                </div>
                <div>
                  <small>
                    Wilber Huacasi <br /> Lizeth Mescua <br /> Iraldia Loyola{" "}
                    <br />
                    Imasumacc Vargas
                  </small>
                </div>

                <div className="mt-2">
                  <small>
                    <strong>Desarrollo web:</strong>
                  </small>
                </div>
                <div>
                  <small>Melissa Chávez</small>
                </div>

                <div className="mt-2">
                  <small className="text-center">
                    Esta herramienta de periodismo de datos fue elaborada en el
                    marco del Curso de Actualización en Periodismo y Política -
                    Edición 2023, de la PUCP, IDEA Internacional y la Fundación
                    Gustavo Mohme Llona.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
